export default __webpack_public_path__ + "static/media/ic_check_white.e1bb9473.svg";